<script>
import classModifierMixin from './mixins/class-modifier-mixin'

export default {
	name: 'BaseButton',
	mixins: [classModifierMixin]
}
</script>
<template>
	<button class="base-button" :class="modifierClasses" v-on="$listeners">
		<slot />
	</button>
</template>
<style lang="scss">
	.base-button {
        align-items: center;
        background-color: var(--background-colour);
        border-radius: var(--border-radius);
        border: 0;
		color: var(--on-background);
        cursor: pointer;
		display: flex;
		font-family: 'Noto Sans JP', 'Roboto', sans-serif;
        font-size: var(--font-size-button);
		font-weight: var(--font-weight-button);
		justify-content: center;
        letter-spacing: 1.25px;
		min-height: 45px;
		padding: 0.75rem 1rem;
        text-transform: uppercase;
		@media (max-width: 320px) {
            min-height: 45px;
			padding: 0.12rem 1rem;
		}
		&:disabled {
			opacity: 0.5;
			background-color: var(--disabled-colour);
			color: var(--on-primary);
			cursor: not-allowed;
			border: 0;
		}
        &--circle {
            border-radius: 50%;
            margin: 0;
            padding: 0;
        }
		&--big-circle {
            font-size: 3.5rem;
            height: 100px;
			width: 100px;
		}
		&--small-circle {
			font-size: 2.5rem;
			height: 75px;
			width: 75px;
		}
		&--xs-circle {
			font-size: 2.2rem;
			height: 60px;
			width: 60px;
		}
		&--xxs-circle {
            font-size: 2.1rem;
			height: 55px;
			width: 55px;
		}
		&--xxxs-circle {
            font-size: 1.2rem;
            min-height: 40px;
			height: 40px;
			width: 40px;
		}
		&--auto-height {
			height: auto;
		}
		&--set-height {
			height: 55px;
			padding: 0;
			@media (max-width: 350px) {
				font-size: 98%;
			}
		}
		&--danger {
			background-color: var(--danger-colour);
            color: var(--on-danger);
		}
        &--danger-secondary {
            color: var(--danger-colour);
            background-color: white;
        }
		&--primary {
			background-color: var(--primary-colour);
			border: 0;
			color: var(--on-primary);
		}
        &--primary-inverse {
           background-color: transparent;
            border: 1px solid var(--primary-colour);
            color: var(--primary-colour);
        }
		&--accent {
			background-color: var(--accent-colour);
			border: 0;
			color: var(--on-accent);
		}
        &--accent-inverse {
            background-color: transparent;
            border: 1px solid var(--accent-colour);
            color: var(--accent-colour);
        }
		&--action {
			background-color: var(--accent-colour);
            border: 0;
			color: var(--button-text-colour-action);
		}
        &--shadow {
            box-shadow: 0 2px var(--background-variant-dark);
        }
        &--font-small {
            font-size: 1rem;
        }
		&--xs {
			width: 80vw;
			max-width: 55px;
		}
		&--small {
			width: 80vw;
			max-width: 150px;
		}
		&--medium {
			width: 80vw;
			max-width: 275px;
		}
		&--large {
			width: 80vw;
			max-width: 350px;
		}
		&--full {
			width: 100%;
            @media (max-width: 500px) {
				min-width: 100%;
				max-width: 100%;
			}
		}
		&--margin-right {
			margin-right: 0.5rem;
		}
		&--margin-y {
			margin: 1rem auto;
		}
		&--centered {
			margin: 0 auto;
		}
		&--padding-1rem {
			padding: 1rem 1.75rem;
		}
		&--cursor {
			&-inherit {
				cursor: inherit;
			}
		}
	}
</style>
